<template>
  <div class="listPage">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button
          class="addBtn"
          @click="showDialog()"
          v-if="null !== addPermission"
          >{{ addPermission.name }}</el-button>
      </div>
      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.roleName"
              placeholder="搜索角色名称"
              @keyup.enter.native="handleCurrentChange(1)"
            >
              <!-- <i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            > -->
            <div slot="suffix" class="searchClass" @click="handleCurrentChange(1)">搜索</div>
          </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        :height="tableHeight"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="roleName"
          label="角色名称"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="upermissionNames"
          label="拥有权限"
          min-width="180"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>

        <el-table-column
          label="操作"
          min-width="40"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'role-edit'"
                  @click="edit(scope.row.id)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #0083fd;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="editBtn"
                  >{{ button.name }}</el-button
                >

                <el-button
                  v-else-if="button.path === 'role-del'"
                  @click="del(scope.row.id)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #c1c1c1;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="delBtn"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 12, 18, 24]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          popper-class="adminHomeSelect"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="420px"
      class="commonDialog rolePage"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        @submit.native.prevent
      >
        <el-form-item label="角色名称" prop="roleName">
          <el-input
            v-model="form.roleName"
            placeholder="请填写角色名称(20字内)"
            maxlength="20"
            clearable
            @keyup.enter.native="submit('form')"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <span slot="label" class="labelClass"
            >赋予权限 &nbsp;
            <div class="numClass">{{ checkedNum }}/{{ totalTreeNum }}</div>
            条</span
          ><el-checkbox
            v-model="checkAll"
            class="checkAllPermission"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
        </el-form-item>

        <div class="treeClass">
          <el-tree
            :data="dataOfTree"
            show-checkbox
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            :default-checked-keys="defaultCheckKeys"
            @check-change="handleCheckChange"
          ></el-tree>
        </div>
      </el-form>
      <div class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submit('form')"
            class="confirmBtn"
            :loading="loading"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { getAllKey } from "@/assets/js/tree/tree.js";
export default {
  name: "role",
  props: ["menuId"],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      addPermission: null,
      buttonList: [],
      title: "添加角色",
      total: 0, //总条数
      tableData: [],
      current: 1, //当前页数
      size: 6, //显示几条
      queryForm: {
        roleName: "",
        removed: 0,
      },
      checkedNum: 0,
      totalTreeNum: 0,
      checkAll: false,
      form: {
        id: "",
        roleName: "",
        permission: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请填写角色名称~", trigger: "blur" },
        ],
      },
      /* 选项列表数据(树形结构的对象数组) */
      dataOfTree: [{}],
      // 该数组回显数据根据所对应的ID  进行默认勾选 (:default-checked-keys 这个) 和 (node-key="id") 这个两个并存
      defaultCheckKeys: [],
      defaultProps: {
        children: "children",
        label: "name", // 这里的名字要和你封装的数据中的节点的名字一样
      },
      tableHeight: 500, // 表格高度
    };
  },
  methods: {
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    getTableHeight() {
      let tableH = 305; // 除表格外其他区域高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = tableHeightDetil;
      }
    },
    //跳出弹框
    showDialog() {
      this.dialogVisible = true;
      this.title = "添加角色";
      this.form = {};
      this.getPermissionTree();
    },
    //获取权限树
    getPermissionTree() {
      this.postJsonRequest("/user-server/api/u-permission/query", {
        removed: 0,
      }).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          this.dataOfTree = data;
          let dataStr = JSON.stringify(data); //将json对象转换成字符串
          let splitArr = dataStr.split('"name":');
          let len = splitArr.length;
          this.totalTreeNum = len == 0 ? 0 : len - 1;

          let permission = this.form.permission;
          if (permission) {
            let oldArr = permission.split(",");
            this.checkedNum = oldArr.length;
            this.$refs.tree.setCheckedKeys(
              getAllKey(data, "id", "children", oldArr),
              true
            ); //重点是这句话，将所需要的数据转换成想要的数据
          } else {
            this.checkedNum = 0;
            this.handleCheckAllChange(false);
          }
          if (this.totalTreeNum > this.checkedNum) {
            this.checkAll = false;
          } else {
            this.checkAll = true;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>获取权限失败";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
        }
      });
    },
    //全选
    handleCheckAllChange(val) {
      if (val) {
        this.$refs.tree.setCheckedNodes(this.dataOfTree);
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
      this.checkAll = val;
    },
    //获取选中和半选中状态下的数据
    handleCheckChange() {
      let res = this.$refs.tree
        .getCheckedNodes()
        .concat(this.$refs.tree.getHalfCheckedNodes());
      let checkedNum = res.length;
      this.checkedNum = checkedNum;
      if (checkedNum === this.totalTreeNum) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    // 提交表单
    submit(formName) {
      try {
        this.loading = true;
        // 进行验证表单内容是否填写正确
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //获取选中和半选中状态下的数据
            let res = this.$refs.tree
              .getCheckedNodes()
              .concat(this.$refs.tree.getHalfCheckedNodes());

            if (0 === res.length) {
              let tips =
                "<i class='el-icon-warn-tip'></i>请给角色赋予对应权限";
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                confirmButtonClass: "confirm-style",
                showCancelButton: false,
              });
              return false;
            } else {
              let permission = "";
              for (let i = 0, leng = res.length; i < leng; i++) {
                let item = res[i];
                permission += item.id;
                if (i !== leng - 1) {
                  permission += ",";
                }
              }
              this.form.permission = permission;
            }
            if (this.form.id) {
              //编辑
              this.update(this.form);
            } else {
              //新增
              this.save(this.form);
            }
          } else {
            return false;
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    // 新增
    save(form) {
      this.postJsonRequest("/user-server/api/u-role/save", form).then((res) => {
        let oData = res.data;
        let _this = this;
        if (oData.code === 0) {
          _this.dialogVisible = false; //关闭弹框
          _this.query();
          this.$message({
            message: "提交成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {},
          });
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
        }
      });
    },
    // 查询
    query(queryType) {
      try {
        this.loading = true;
        let params = {};
        let current = 1;
        let size = 6;
        if (queryType === "queryById") {
          params = {
            ...this.form,
          };
        } else {
          params = { ...this.queryForm };
          current = this.current;
          size = this.size;
        }
        this.postJsonRequest(
          "/user-server/api/u-role/query?current=" + current + "&size=" + size,
          params
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (queryType === "queryById") {
              this.form = data.records[0];
              this.getPermissionTree();
            } else {
              this.tableData = data.records;
              this.total = data.total;
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    //编辑
    edit(id) {
      this.dialogVisible = true;
      this.title = "编辑角色";
      this.getPermissionTree();
      this.form = {};
      this.form.id = id;
      this.query("queryById");
    },
    // 编辑
    update(form) {
      this.putJsonRequest("/user-server/api/u-role/update", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 删除
    del(id) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.deleteRequest("/user-server/api/u-role/delete?id=" + id).then(
            (res) => {
              let oData = res.data;
              if (oData.code == 0) {
                let totalPage = Math.ceil((this.total - 1) / this.size);
                let currentPage =
                  this.current > totalPage ? totalPage : this.current;
                this.current = currentPage < 1 ? 1 : currentPage;
                this.query();
                this.$message({
                  message: "删除成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {},
                });
              } else if (oData.code != 401) {
                let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
                this.$confirm(tips, "提示", {
                  confirmButtonText: "好的",
                  customClass: "customClass-style",
                  iconClass: "",
                  dangerouslyUseHTMLString: true,
                  confirmButtonClass: "confirm-style",
                  showCancelButton: false,
                });
              }
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];

          if (child) {
            if (child.path === "role-add") {
              this.addPermission = child;
            } else if (child.path !== "role-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  created() {
    this.getTableHeight();
  },
  watch: {
    dialogVisible: function (nval, oval) {
      this.defaultClearValidate("form");
    },
  },
};
</script>

<style scoped>
.labelClass {
  display: flex;
  flex-direction: row;
}
.searchClass{

  width: 51px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #00aeff;
  line-height: 16px;
  margin-top: 10px;
  border-left: 1px solid #00aeff;
}
.numClass {
  color: #00aeff;
}
.el-checkbox:last-of-type {
  float: right;
  /* margin-top: -11px; */
}
.treeClass {
  margin: 0 auto;
  margin-top: -35px;
  width: 360px;
  height: 230px;
  background: transparent;
  /* opacity: 0.5; */
  border: 1px solid #00aeff;
  overflow: auto;
}
>>>.el-dialog__header {
    /* background-image: url(../../img/common/tableHead.png); */
    /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
    /* padding: 20px 20px 0px 40px ; */
    background: url(../../../assets/img/2dmap/pop_bg.png)  no-repeat;
    /* background-position: 6px 25px; */
    background-position: left bottom;
}
/* .el-scrollbar .el-scrollbar__wrap {
  background-color: #0083fd !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/admin/user/role.vue